const theme = {
  initialColorModeName: "light",
  initialColorMode: "light",
  useColorSchemeMediaQuery: true,
  useLocalStorage: false,
  breakpoints: ["40em", "52em", "64em", "120em", "140em"],
  colors: {
    text: "#3d3d37",
    heading: "#3d3d37",
    bigTitle: "#3d3d37",
    background: "#f3f3f3",
    primary: "#3d3d37",
    primaryInteractive: "#f0c844",
    borderColor: "rgba(0,0,0,0.3)",
    borderColorQuiet: "rgba(0,0,0,0.1)",
    inverted: "#fff",
    bgImg: "#f3f3f3",
    coverBook:"#f0c844",
    modes: {
      dark: {
        text: "#c6c6c6",
        heading: "#cccccc",
        bigTitle: "#c6c6c6",
        background: "#121212",
        primary: "#f0c844",
        primaryInteractive: "#f0c844",
        borderColor: "rgba(255,255,255,0.4)",
        borderColorQuiet: "rgba(255,255,255,0.1)",
        inverted: "#fff",
        bgImg: "#f3f3f3",
        coverBook:"#f0c844",
      },
      pink: {
        text: "#081E00",
        heading: "#081E00",
        bigTitle:"#324229",
        background: "#FEEDED",
        primary: "#007337",
        primaryInteractive: "#007337",
        borderColor: "rgba(0,0,0,0.15)",
        borderColorQuiet: "rgba(0,0,0,0.1)",
        inverted: "#fff",
        bgImg: "#FEEDED",
        coverBook:"#f7b119",
      },
    },
  },
  space: [0, 4, 8, 16, 32, 64, 128, 256],
  radii: {
    default: 99,
  },
  fonts: {
    body: "Graphik Web, system-ui, sans-serif",
    heading: "inherit",
    display: "FK Screamer, system-ui, sans-serif",
  },
  fontWeights: {
    body: 400,
    heading: 700,
    bold: 600,
    medium: 500,
  },
  lineHeights: {
    body: 1.618,
    heading: 1,
    display: 0.875,
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 28, 32, 36, 44, 48],
  buttons: {
    primary: {
      color: "background",
      bg: "bigTitle",
      fontFamily: "body",
      fontWeight: "bold",
      fontSize: [2,3],
      borderRadius: "default",
      lineHeight: "body",
      px: 4,
      py: 2,
      "&:hover": {
        backgroundColor: "primaryInteractive",
      },
      display: "inline-block",
    },
    outline: {
      color: "text",
      bg: "transparent",
      fontWeight: "body",
      borderRadius: "default",
      borderWidth: "1px",
      borderColor: "borderColor",
      borderStyle: "solid",
      "&:hover": {
        opacity: "0.85",
      },
    },
    themeDot: {
      borderRadius: "default",
      bg: "background",
      width: 32,
      height: 32,
      borderWidth: "1px",
      borderColor: "borderColor",
      borderStyle: "solid",
      mx: [3, 4],
      padding: "0",
      color: "text",
    },
  },
  text: {
    heading: {
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading",
      color: "heading",
      mb: [2, 3],
    },
    bigTitle: {
      fontFamily: "display",
      fontWeight: "heading",
      fontSize: ["calc(0.75rem + 16vw)", "calc(0.75rem + 12vw)", "12vw"],
      color: "bigTitle",
      lineHeight: "display",
      letterSpacing: "[0, 0.25]",
      mt: 3,
      display: "block",
      width: "100%",
      "& > span": {
        display: "inline-block",
        position: "relative",
      },
      "& > span.outline": {
        WebkitTextFillColor: "transparent",
        WebkitTextStrokeWidth: ["1px", "1px","1px", "2px"],
        WebkitTextStrokeColor: "inherit",
      },
      "& > sup": {
        fontSize: "50%",
        textTransform: "none!important",
      },
    },
    bigTitleS: {
      fontFamily: "display",
      fontWeight: "heading",
      color: "bigTitle",
      fontSize: ["14vw", "10vw"],
      // textTransform: "uppercase",
      whiteSpace: "nowrap",
      lineHeight: "0.875",
      wordSpacing: "0.1em"
    },
    bigTitleXS: {
      fontFamily: "body",
      color: "heading",
      letterSpacing:"-0.012em",
      fontSize: [5,9],
      lineHeight: "1.15",
      pb: [2, 3],
    },
    catHeading: {
      fontFamily: "body",
      fontSize: ["1rem","1.15rem"],
      fontWeight: "body",
      textTransform: "uppercase",
      letterSpacing: "0.025em",
      opacity: "0.64",
      borderWidth: "1px 0 0",
      borderStyle: "solid",
      borderColor: "borderColorQuiet",
      pt: [3, 4],
      mb: [2, 3],
    },
    paragraph: {
      maxWidth: "75em",
      pb: [3, 4],
    },
    parapgraphXL: {
      fontSize: "calc(1.6rem + 0.35vw)",
      lineHeight: "body",
    },
    caption: {
      fontSize: [1,1,1,1,"calc(0.75rem + 0.25vw)"],
      lineHeight: 1.75,
      display: "block",
      py: [2,4],
      pt: [3],
      opacity: "0.85",
      textAlign: "left",
      maxWidth: "48rem",
    },
    quote: {
      fontSize: [4,5,6],
      fontWeight: "medium",
      lineHeight: "1.5",
      maxWidth: "56.4rem",
      float: "right",
      px:[1,2,3,4]
    }
  },
  links: {
    nav: {
      fontWeight: "heading",
      fontSize: [2,3],
      position: "relative",
      lineHeight: "body",
      borderRadius: "default",
      display: "inline-block",
      borderWidth: "1px",
      borderColor: "borderColor",
      borderStyle: "solid",
      bg: "background",
      px: ["2.4rem",4],
      py: [2],
      transition: "border-color 0.2s ease-in-out",
      "&.active": {
        color: "background",
        bg: "bigTitle"
      },
      "&:hover": {
        borderColor: "bigTitle"
      }
    },
    imgLink: {
      display: "block",
      cursor: "pointer",
      "&.active": {
        position: "relative",
        opacity: "0.5"
      },
      "&.active::after": {
        content:'" "',
        position: "absolute",
        width: "90%",
        maxWidth:["60vw","50vw"],
        height: ["60%","160%"],
        maxHeight: ["16rem","24rem"],
        borderRadius: "50%",
        top: ["0" ,"-6%"],
        left: "-3vw",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "text",
        transform:"rotate(5deg)",
        transition: "transform 0.2s ease-in-out"
      },
      "&.active:hover::after": {
        transform:"rotate(-1deg)",
        transition: "transform 0.2s ease-in-out"
      },
    },
  },
  styles: {
    // root: {
    //   transitionProperty: "background-color",
    //   transitionTimingFunction: "ease-in-out",
    //   transitionDuration: ".15s",
    // },
    p: {
      mb: [3, 4, 5],
      pr: [0, 4, 5],
    },
  },
  variants: {
    aLink: {
      position: "relative",
      lineHeight: "body",
      display: "inline-block",
      pb: 1/2,
      fontWeight: "medium",
      "&:after": {
        content: '" "',
        width: "100%",
        height: "2px",
        backgroundColor: "borderColor",
        position: "absolute",
        bottom: "0",
        left: "0",
      },
      "&:hover:after": {
        backgroundColor: "bigTitle",
      },
    },
    container: {
      width: "100vw",
      maxWidth: ["88vw","92vw"],
      mx: "auto",
      pt: [5],
      mb: [0,2,3,5,6,7]
    },
    containerHero: {
      width: "100vw",
      maxWidth: ["88vw","92vw"],
      mx: "auto",
      pb: [3, 4],
      mt:[1,2,2,6,2],
      mb: [0,2,3,5]
    },
    containerHeader: {
      width: "100vw",
      maxWidth: ["88vw","92vw"],
      mx: "auto",
      pt: [3,4],
    },
    containerPage: {
      maxWidth: "92vw",
      mx: "auto",
      my: [3,4,5,6],
    },
    containerTxt: {
      width: "100%",
      maxWidth: ["76.4rem", "76.4rem", "76.4rem", "88.4rem"],
      mt: [3,4],
      mb: [4, 5],
    },
    containerRelatedProject: {
      width: "100%",
      borderWidth: "0px 0px 0px",
      borderStyle: "solid",
      "&:nth-of-type(2)": {
        borderWidth: "1px 0px 1px",
      },
      borderColor: "borderColorQuiet",
      py:[3,4],
    },
    containerBigTitle: {
      borderWidth:["0 0 0 0", "0 1px 0 0"],
      borderStyle: "solid",
      borderColor: "borderColorQuiet",
      mb: [3],
    },
    containerSmallSreen: {
      maxWidth: "32rem"
    },
    wrapperVideo: {
      position: "relative",
      pb: "51.56%",
      height: "0",
      overflow: "hidden",
      "& > video": {
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
      },
      "&:before": {
        width: "100%",
        height: "100%",
        position: "absolute",
        backgroundColor: "background"
      }
    },
    wrapperVideoIFrame: {
      position: "relative",
      pb: "51.56%",
      height: "0",
      overflow: "hidden",
      "& > iframe": {
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
      },
      "&:before": {
        width: "100%",
        height: "100%",
        position: "absolute",
        backgroundColor: "background"
      }
    },
    wrapperVideoPortrait: {
      position: "relative",
      pb: "173.18%",
      height: "0",
      overflow: "hidden",
      "& > video": {
        position: "absolute",
        top: "4px",
        left: "1px",
        width: "calc(100% + 2px)",
        height: "calc(100% + 8px)",
      },
      "&:before": {
        width: "100%",
        height: "100%",
        position: "absolute",
        backgroundColor: "background"
      }
    },
    projectCard: {
      m: 0,
      mb:[1,2,4],
      px: [0,2,4,5],
      transitionProperty: "opacity",
      transitionTimingFunction: "ease-out",
      transitionDuration: "0.1s",
      '@media screen and (min-width: 40em)': {
        borderWidth: "0 1px 0 0",
        borderStyle: "solid",
        borderColor: "borderColorQuiet",
      },
      "&:hover": {
        opacity: "0.75",
      },
      "&:last-of-type": {
        borderWidth: "0 0 0 0",
        pr:[0,0,0,0]
      },
      "&:first-of-type": {
        pl: [0,0,0]
      },
    },
    quote: {
      fontSize: "calc(100% + 0.75vw)",
      lineHeight: "1.25",
      mt: [1, 2, 3],
      mb: [2, 3, 4],
      letterSpacing: "normal",
    },
    wrapperImg: {
      position: "relative",
      width: "100%",
      height: "auto",
      textAlign: "center",
      "& img": {
        mixBlendMode: "multiply",
      },
      "&:before": {
        content: '" "',
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "bgImg",
      },
    },
    wrapperImgBorder: {
      position: "relative",
      width: "100%",
      height: "auto",
      textAlign: "center",
      "& img": {
        mixBlendMode: "multiply",
        borderWidth: "1px", 
        borderStyle: "solid", 
        borderColor: "borderColorQuiet"
      },
      "&:before": {
        content: '" "',
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "bgImg",
      },
    },
    pageTransition: {
      color: "bgImg",
    },
  },
};

export default theme;
